import {createContext, FC, useContext, useState} from 'react'
import {WebFormStatus} from '../../../@types'
import {triggerReloadInterface} from '../../../@types/global'

interface FormsContextType extends triggerReloadInterface {
  allStatus: WebFormStatus[]
  setAllStatus: (s: WebFormStatus[]) => void
}

const initialStatus = [
  {id: "0", name: "À traiter", bg: "danger"},
  {id: "1", name: "En cours", bg: "primary"},
  {id: "2", name: "Finalisé", bg: "success"},
  {id: "3", name: "Ré-ouverture", bg: "info"}
]

const FormsContext = createContext<FormsContextType | undefined>(undefined)

export const FormsProvider: FC = ({children}) => {

  const [reloadKey, setReloadKey] = useState<number>(0)
  const [allStatus, setAllStatus_] = useState<WebFormStatus[]>(initialStatus)

  const triggerReload = () => setReloadKey(prevKey => prevKey + 1)
  const setAllStatus = (s: WebFormStatus[]) => setAllStatus_(s)

  return (
    <FormsContext.Provider value={{reloadKey, triggerReload, allStatus, setAllStatus}}>
      {children}
    </FormsContext.Provider>
  )
}

export const useForms = () => {
  const context = useContext(FormsContext);
  if (!context) throw new Error('useForms must be used within FormsProvider');
  return context;
};